import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './Contact.css';

class Contact extends Component {
  render() {
    return (
      <div id="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <p>Fill out the form below for more information about Zygous Labs.</p><br/><br/>
          <div className="form">
            <form action="https://formspree.io/info@zygouslabs.com" method="POST">
              <input type="text" name="firstname" placeholder="First Name"/>
              <input type="text" name="lastname" placeholder="Last Name"/>
              <input type="email" name="email" placeholder="Email"/>
              <input type="text" name="phone" placeholder="Phone"/>
              <input type="text" name="role" placeholder="Role"/>
              <textarea name="questions" placeholder="Questions or Comments"/>
              <input type="hidden" name="_next" value="/ThankYou" />
              <input type="hidden" name="_subject" value="New Contact Submission!\" />
              <input type="hidden" name="_format" value="plain" />
              <input type="submit" value="Submit"/>
            </form>
          </div>
        </div>
      </div>

    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Contact.js